import Notices from "./Notices";

export default class Wishlist {
	constructor() {
		this.addToWishlistBtns = document.querySelectorAll(".jsAddToWishlist");
		this.noticeContainer = document.querySelector(".jsPageNoticeWrapper");
		this.notices = new Notices();

		if (this.addToWishlistBtns) {
			this.events();
		}
	}

	events() {
		this.addToWishlistBtns.forEach((btn) => {
			btn.addEventListener("click", (e) => {
				e.preventDefault();
				if (e.target.classList.contains(".jsAddToWishlist")) {
					this.addToWishlist(e.target);
				} else {
					this.addToWishlist(e.target.closest(".jsAddToWishlist"));
				}
			});
		});
	}

	addToWishlist(item) {
		fetch(window.global.ajax_url + "?action=addProductToWishlist", {
			method: "POST", //* GET, POST, PUT, DELETE, etc.
			mode: "cors", // no-cors, *cors, same-origin
			cache: "no-cache", //* default, no-cache, reload, force-cache, only-if-cached
			credentials: "same-origin", // include, *same-origin, omit
			headers: {
				// "Content-Type": "application/json",
				"Content-Type": "application/x-www-form-urlencoded",
			},
			redirect: "follow", // manual, *follow, error
			referrerPolicy: "no-referrer", // no-referrer, *client
			body: new URLSearchParams({
				security: window.global.security,
				productId: item.dataset.productId,
			}),
		})
			.then((response) => response.json())
			.then((data) => {
				if (data.success) {
					let addContainer = item.querySelector(".wc-product__wishlist-inner--add");
					let addedContainer = item.querySelector(".wc-product__wishlist-inner--added");
					if(addContainer) addContainer.classList.toggle("is-active");
					if(addedContainer) addedContainer.classList.toggle("is-active");

					if (item.dataset.removable) {
						location.reload();
					}

					this.notices.addNotices(data.data.notices, 10000);
				}
			});
	}
}
